module.exports = __webpack_public_path__ + "static/img/2.9e0562a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/7/2.png
// module id = sXpd
// module chunks = 1